import { render } from "./FamilyGroups.vue?vue&type=template&id=50dae9b0&scoped=true"
import script from "./FamilyGroups.vue?vue&type=script&lang=js"
export * from "./FamilyGroups.vue?vue&type=script&lang=js"

import "./FamilyGroups.vue?vue&type=style&index=0&id=50dae9b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50dae9b0"]])

export default __exports__